// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__tD36E"};